import PropTypes from 'prop-types';
import React, {useCallback, useEffect, useState} from 'react';

import LoginHub from '../login-hub/login-hub.jsx';
import StaffPortal from '../staff-portal/staff-portal.jsx';
import PlatformPortal from '../platform-portal/platform-portal.jsx';
import {getLabcodeStaffProfile, hasLabcodeStaffSession} from '../../lib/labcode-staff-session';
import {hasLabcodeStudentSession} from '../../lib/labcode-student-session';
import {isLabcodeFullAuthGateActive} from '../../lib/labcode-auth-config';

/**
 * Modo full: exige login (aluno → editor; equipa escolar → portal com dashboard/turmas/projetos/editor).
 */
const LabcodeAuthGate = ({children}) => {
    const gateActive = isLabcodeFullAuthGateActive();
    const [, bumpSession] = useState(0);

    const refresh = useCallback(() => {
        if (!gateActive) return;
        bumpSession(n => n + 1);
    }, [gateActive]);

    const studentOk = hasLabcodeStudentSession();
    const staffOk = hasLabcodeStaffSession();

    useEffect(() => {
        if (!gateActive) return undefined;
        const onStudent = () => refresh();
        const onStaff = () => refresh();
        window.addEventListener('labcode-student-session-changed', onStudent);
        window.addEventListener('labcode-staff-session-changed', onStaff);
        return () => {
            window.removeEventListener('labcode-student-session-changed', onStudent);
            window.removeEventListener('labcode-staff-session-changed', onStaff);
        };
    }, [gateActive, refresh]);

    if (!gateActive) {
        return children;
    }

    if (studentOk) {
        return children;
    }

    if (staffOk) {
        const p = getLabcodeStaffProfile();
        if (p && p.role === 'platform_admin') {
            return <PlatformPortal>{children}</PlatformPortal>;
        }
        return <StaffPortal>{children}</StaffPortal>;
    }

    return <LoginHub />;
};

LabcodeAuthGate.propTypes = {
    children: PropTypes.node
};

export default LabcodeAuthGate;
